import { useState, useEffect } from 'react'
import type { ProyectoPlan } from './tipos'
import { SelectorUbicacion } from '@/modules/ordenes-servicio/SelectorUbicacion'
import { IconoMapa, IconoCerrar } from '@/shared/ui/Iconos/Iconos'
import estilos from './PlanProyectos.module.css'

type Props = {
  abierto: boolean
  proyecto?: ProyectoPlan | null
  onCerrar: () => void
  onGuardar: (lat: number | null, lng: number | null, radio: number, direccion?: string) => void
}

/** Cartago, centro de operaciones de MEGA */
const CARTAGO_DEFECTO = { lat: 4.746, lng: -75.9115 }

export function ModalMapaUbicacionProyecto({ abierto, proyecto, onCerrar, onGuardar }: Props) {
  const [direccion, setDireccion] = useState(proyecto?.ubicacion || '')
  const [punto, setPunto] = useState<{ lat: number; lng: number } | null>(() => {
    if (proyecto?.latitud != null && proyecto?.longitud != null) {
      return { lat: Number(proyecto.latitud), lng: Number(proyecto.longitud) }
    }
    return CARTAGO_DEFECTO
  })
  const [radioGeocerca, setRadioGeocerca] = useState(proyecto?.radio_geocerca_m || 80)

  useEffect(() => {
    setDireccion(proyecto?.ubicacion || '')
    if (proyecto?.latitud != null && proyecto?.longitud != null) {
      setPunto({ lat: Number(proyecto.latitud), lng: Number(proyecto.longitud) })
    } else {
      setPunto(CARTAGO_DEFECTO)
    }
    setRadioGeocerca(proyecto?.radio_geocerca_m || 80)
  }, [proyecto, abierto])

  if (!abierto) return null

  function handleGuardar() {
    onGuardar(punto ? punto.lat : null, punto ? punto.lng : null, radioGeocerca, direccion)
    onCerrar()
  }

  return (
    <div className={estilos.modalVelo} onClick={onCerrar}>
      <div
        className={estilos.modalCaja}
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '680px',
          width: '95%',
          background: '#3A196E',
          border: '2px solid #ffc43f',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.7)',
        }}
      >
        <header className={estilos.modalHeader}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <IconoMapa style={{ width: '20px', height: '20px', color: '#ffc43f' }} />
            <div>
              <h3 style={{ color: '#ffffff', margin: 0, fontSize: '1.1rem', fontWeight: 800 }}>
                Ubicación GPS y Geocelda de la Obra
              </h3>
              <p style={{ margin: '2px 0 0', fontSize: '12px', color: '#e5d8ff' }}>
                {proyecto?.nombre || 'Proyecto'}
              </p>
            </div>
          </div>
          <button
            type="button"
            className={estilos.btnCerrarModal}
            onClick={onCerrar}
            title="Cerrar modal"
          >
            <IconoCerrar />
          </button>
        </header>

        {/* Campo de Dirección o Municipio */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '4px' }}>
          <label style={{ fontSize: '12px', fontWeight: 800, color: '#ffc43f', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
            Dirección o Municipio de la Obra:
          </label>
          <input
            type="text"
            value={direccion}
            placeholder="Ej: Cartago, Balboa, Carrera 4 # 10-20"
            onChange={(e) => setDireccion(e.target.value)}
            style={{
              background: '#250d4a',
              border: '1.5px solid #8247E5',
              color: '#ffffff',
              padding: '9px 14px',
              borderRadius: '6px',
              fontSize: '13.5px',
              fontWeight: 600,
            }}
          />
        </div>

        {/* Selector de Mapa GPS */}
        <div style={{ marginTop: '8px' }}>
          <SelectorUbicacion
            punto={punto}
            onPunto={setPunto}
            direccion={direccion}
            inicializarMapaAbierto={true}
          />
        </div>

        {/* Radio Geocerca */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '10px',
            marginTop: '8px',
            padding: '12px 16px',
            background: '#2B1254',
            border: '1.5px solid #7339CE',
            borderRadius: '8px',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ color: '#ffffff', fontSize: '0.92rem', fontWeight: 800 }}>
              Radio geocerca en sitio:
            </span>
            <input
              type="number"
              min={20}
              max={1000}
              step={10}
              value={radioGeocerca}
              onChange={(e) => setRadioGeocerca(Number(e.target.value) || 80)}
              style={{
                width: '85px',
                padding: '0.4rem 0.6rem',
                borderRadius: '6px',
                border: '1.5px solid #ffc43f',
                background: '#1a0033',
                color: '#ffffff',
                fontWeight: 900,
                fontSize: '1rem',
                textAlign: 'center',
              }}
            />
            <span style={{ color: '#e5d8ff', fontSize: '0.9rem', fontWeight: 700 }}>
              metros
            </span>
          </div>

          {punto && (
            <div style={{ fontSize: '0.85rem', color: '#ffc43f', fontWeight: 800 }}>
              GPS: {punto.lat.toFixed(5)}, {punto.lng.toFixed(5)}
            </div>
          )}
        </div>

        <footer className={estilos.modalFooter}>
          <button
            type="button"
            className={estilos.btnCancelar}
            onClick={onCerrar}
          >
            Cancelar
          </button>
          <button
            type="button"
            className={estilos.btnGuardar}
            onClick={handleGuardar}
            style={{
              background: '#ffc43f',
              color: '#1a0033',
              border: 'none',
              fontWeight: 800,
              boxShadow: '0 4px 14px rgba(255, 196, 63, 0.4)',
            }}
          >
            Guardar Ubicación
          </button>
        </footer>
      </div>
    </div>
  )
}
